// src/EditHorse.js
import React, { useState, useEffect } from "react";
import { db, storage, auth } from "./firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useParams, useNavigate } from "react-router-dom";

export default function EditHorse({ horse: horseProp, onClose }) {
  const { id: routeId } = useParams(); // when coming from /edit/:id
  const navigate = useNavigate();

  const [ownername, setOwnername] = useState("");
  const [contact, setContact] = useState("");
  const [horse, setHorse] = useState(horseProp || null);
  const [name, setName] = useState(horseProp?.name || "");
  const [age, setAge] = useState(horseProp?.age || "");
  const [breed, setBreed] = useState(horseProp?.breed || "");
  const [description, setDescription] = useState(horseProp?.description || "");
  const [image, setImage] = useState(null);

  // 🔄 Fetch if opened via route (not inline card)
  useEffect(() => {
    if (!horseProp && routeId) {
      const fetchHorse = async () => {
        const docRef = doc(db, "horses", routeId);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          setOwnername(data.ownername || "");
          setContact(data.contact || "");
          setHorse({ id: snapshot.id, ...data });
          setName(data.name || "");
          setAge(data.age || "");
          setBreed(data.breed || "");
          setDescription(data.description || "");
        }
      };
      fetchHorse();
    }
  }, [routeId, horseProp]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const horseId = horseProp?.id || routeId;

    if (!auth.currentUser || auth.currentUser.uid !== horse.owner) {
      alert("Not authorized to edit this horse.");
      return;
    }

    let imageUrl = horse.imageUrl;
    if (image) {
      const imageRef = ref(
        storage,
        `horses/${auth.currentUser.uid}/${Date.now()}_${image.name}`
      );
      await uploadBytes(imageRef, image);
      imageUrl = await getDownloadURL(imageRef);
    }

    const docRef = doc(db, "horses", horseId);
    await updateDoc(docRef, {
      ownername,
      contact,
      name,
      age,
      breed,
      description,
      imageUrl,
      updatedAt: new Date(),
    });

    alert("Horse updated!");

    if (onClose) {
      onClose(); // 👈 closes inline editor
    } else {
      navigate(`/horse/${horseId}`); // 👈 go back to detail page if standalone
    }
  };

  if (!horse) return <p>Loading...</p>;

  return (
    <div style={{ maxWidth: "500px", margin: "2rem auto" }}>
      <h2>Edit Horse Profile</h2>
      <form
        onSubmit={handleUpdate}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <input
          type="text"
          value={ownername}
          onChange={(e) => setOwnername(e.target.value)}
          placeholder="Owner Name"
        />
        <input
          type="text"
          value={contact}
          onChange={(e) => setContact(e.target.value)}
          placeholder="Contact"
        />
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Horse Name"
        />
        <input
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
          placeholder="Age"
        />
        <input
          type="text"
          value={breed}
          onChange={(e) => setBreed(e.target.value)}
          placeholder="Breed"
        />
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
        />
        <input type="file" onChange={(e) => setImage(e.target.files[0])} />

        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button type="submit" style={{ flex: 1, background: "green", color: "white" }}>
            Update Horse
          </button>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              style={{ flex: 1, background: "gray", color: "white" }}
            >
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
